// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Inventory2Outlined,
  SettingsOutlined,
} from '@/constants/hardfin-standard-icons';
import { ShipmentItem } from '@/shipment/api/types';

interface Props {
  item: Pick<ShipmentItem, 'item'>;
}

/**
 * Displays an icon indicating whether the shipment item is a bulk item or device.
 * - SettingsOutlined for bulk items (!hasAssets)
 * - Inventory2Outlined for devices (hasAssets)
 */
export function ShipmentItemTypeIcon(props: Props) {
  if (props.item.item.hasAssets) {
    return <Inventory2Outlined sx={{ fontSize: '1rem' }} />;
  }

  return <SettingsOutlined sx={{ fontSize: '1rem' }} />;
}
